/**
 * Stytch's `oauth.*.start()` navigates the main WebView via `window.location`.
 * On native (Capacitor) that unloads the running app — the WebView goes blank and
 * the OAuth flow is handed to the external browser with no reliable way back.
 *
 * This redirects that single navigation into an in-app browser
 * (SFSafariViewController / Chrome Custom Tabs) instead, so the app's WebView stays
 * alive. The Stytch SDK still builds the start URL and manages PKCE (it stores the
 * code_verifier in this WebView's localStorage, which `oauth.authenticate()` reads
 * on return); only the final `window.location` redirect is swapped out. The custom
 * scheme in `STYTCH_OAUTH_REDIRECT_URL` brings the user back via the deep-link handler.
 *
 * `navigate` is the SDK's documented override seam ("Public so it can be mocked in
 * tests"). Mutates the passed OAuth client in place.
 */
export interface OAuthNavigable {
  navigate?: (url: URL | string) => void;
}

export const redirectStytchOAuthToInAppBrowser = (
  oauthClient: OAuthNavigable,
  openInAppBrowser: (url: string) => void,
): void => {
  if (typeof oauthClient.navigate !== "function") {
    return;
  }

  oauthClient.navigate = (url: URL | string): void => {
    openInAppBrowser(url.toString());
  };
};
